import { render, staticRenderFns } from "./m-article-image.vue?vue&type=template&id=65af0481"
import script from "./m-article-image.vue?vue&type=script&lang=js"
export * from "./m-article-image.vue?vue&type=script&lang=js"
import style0 from "./m-article-image.vue?vue&type=style&index=0&id=65af0481&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports